var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.5 16.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 3.875C9 3.46079 8.66421 3.125 8.25 3.125C7.83579 3.125 7.5 3.46079 7.5 3.875H8.25H9ZM8.25 8.25H7.5C7.5 8.66421 7.83579 9 8.25 9V8.25ZM12.625 9C13.0392 9 13.375 8.66421 13.375 8.25C13.375 7.83579 13.0392 7.5 12.625 7.5V8.25V9ZM15.75 8.25H15C15 11.9779 11.9779 15 8.25 15V15.75V16.5C12.8063 16.5 16.5 12.8063 16.5 8.25H15.75ZM8.25 15.75V15C4.52208 15 1.5 11.9779 1.5 8.25H0.75H0C0 12.8063 3.69365 16.5 8.25 16.5V15.75ZM0.75 8.25H1.5C1.5 4.52208 4.52208 1.5 8.25 1.5V0.75V0C3.69365 0 0 3.69365 0 8.25H0.75ZM8.25 0.75V1.5C11.9779 1.5 15 4.52208 15 8.25H15.75H16.5C16.5 3.69365 12.8063 0 8.25 0V0.75ZM8.25 3.875H7.5V8.25H8.25H9V3.875H8.25ZM8.25 8.25V9H12.625V8.25V7.5H8.25V8.25Z",
    fill: "var(--stroke-0, #9698A3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d3e934767b545b3811482b056359586e.svg";
export { ForwardRef as ReactComponent };